/* tslint:disable */
/* eslint-disable */
/**
 * FraudFighter API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ProjectItemDto
 */
export interface ProjectItemDto {
    /**
     * 
     * @type {string}
     * @memberof ProjectItemDto
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof ProjectItemDto
     */
    name?: string | null;
}

export function ProjectItemDtoFromJSON(json: any): ProjectItemDto {
    return ProjectItemDtoFromJSONTyped(json, false);
}

export function ProjectItemDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ProjectItemDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'name': !exists(json, 'name') ? undefined : json['name'],
    };
}

export function ProjectItemDtoToJSON(value?: ProjectItemDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'name': value.name,
    };
}


